module.exports = __webpack_public_path__ + "img/pix-red.c134000d.svg";